var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column text-center pa-4"},[_c('m-language',{attrs:{"label":_vm.$t('profile.personal.languages')},model:{value:(_vm.languages),callback:function ($$v) {_vm.languages=$$v},expression:"languages"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }